import React from 'react';

const SEGMENTS = 10;

function toneFor(score) {
  if (score < 40) return 'danger';
  if (score < 70) return 'warn';
  return 'success';
}

/**
 * Barra segmentada 0-100 (10 tramos) con color segun el score global.
 * Usada en la pildora "Salud del vault" del dashboard.
 */
function HealthBar({ score = 0, showScore = true, className = '' }) {
  const clamped = Math.max(0, Math.min(100, score));
  const filled = Math.round((clamped / 100) * SEGMENTS);
  const tone = toneFor(clamped);

  return (
    <div className={`sgc-health-bar ${className}`}>
      <div className="sgc-health-bar__track" role="meter" aria-valuenow={clamped} aria-valuemin={0} aria-valuemax={100}>
        {Array.from({ length: SEGMENTS }).map((_, i) => (
          <span
            key={i}
            className={`sgc-health-bar__seg ${i < filled ? `sgc-health-bar__seg--${tone}` : ''}`}
          />
        ))}
      </div>
      {showScore && <span className={`sgc-health-bar__score sgc-health-bar__score--${tone}`}>{clamped}/100</span>}
    </div>
  );
}

export default HealthBar;
